import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { iconSize } from '@guardian/src-foundations/size';
export const SvgHouse = ({ size }) => {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size ? iconSize[size] : undefined, viewBox: "0 0 30 30" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 25l1-1V13.375L15.6 6h-1.2L7 13.375V24l1 1h4.5v-6.5h5V25H22z" }, void 0) }), void 0));
};
//# sourceMappingURL=house.js.map
